import React from "react";

interface WorkWebToggleProps {
  /** Whether the toggle is disabled */
  isInputDisabled?: boolean;
  /** Current state of web mode (true = Web, false = Work) */
  IsWebEnabled: boolean;
  /** Callback when toggle state changes */
  setIsWebEnabled: (enabled: boolean) => void;
  /** Background color for active toggle button */
  workWebToggleActiveBgColor?: string;
  /** Text color for inactive toggle button */
  workWebToggleInactiveTextColor?: string;
  /** Text color for active toggle button */
  workWebToggleTextColor?: string;
  /** Label for the work mode button */
  workLabel?: string;
  /** Label for the web mode button */
  webLabel?: string;
  /** Optional callback when Web button is clicked */
  onWebClick?: () => void;
  /** Whether web mode is allowed (if false, web button will be disabled) */
  isWebAllowed?: boolean;
}

/**
 * Reusable Work/Web mode toggle component
 * Allows users to switch between Work mode and Web mode
 */
const WorkWebToggle: React.FC<WorkWebToggleProps> = ({
  isInputDisabled = false,
  IsWebEnabled,
  setIsWebEnabled,
  workWebToggleActiveBgColor = "#e8e5e5",
  workWebToggleInactiveTextColor = "#CCCCCC",
  workWebToggleTextColor = "#0099a0",
  workLabel = "Work",
  webLabel = "Web",
  onWebClick,
  isWebAllowed = true,
}) => {
  return (
    <div className="flex items-center justify-center bg-transparent h-[6vh] sm:h-[8vh] w-full">
      <div className="inline-flex rounded-lg overflow-hidden border border-[#E9E2D5]">
        <button
          onClick={() => {
            if (!isInputDisabled) setIsWebEnabled(false);
          }}
          title={IsWebEnabled ? `${workLabel} mode is off` : `${workLabel} mode is on`}
          className={`p-2 sm:px-4 py-2 text-xs sm:text-sm font-medium ${
            isInputDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
          }`}
          style={{
            color: IsWebEnabled
              ? workWebToggleInactiveTextColor
              : workWebToggleTextColor,
            backgroundColor: IsWebEnabled
              ? workWebToggleActiveBgColor
              : undefined,
          }}
          disabled={isInputDisabled}
        >
          {workLabel}
        </button>
        <button
          className={`p-2 sm:px-4 py-2 text-xs sm:text-sm font-medium ${
            isInputDisabled || !isWebAllowed ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
          }`}
          style={{
            color: !IsWebEnabled
              ? workWebToggleInactiveTextColor
              : workWebToggleTextColor,
            backgroundColor: !IsWebEnabled
              ? workWebToggleActiveBgColor
              : undefined,
          }}
          onClick={() => {
            if (!isInputDisabled && isWebAllowed) {
              setIsWebEnabled(true);
              if (onWebClick) {
                onWebClick();
              }
            }
          }}
          title={!IsWebEnabled ? `${webLabel} mode is off` : `${webLabel} mode is on`}
          disabled={isInputDisabled || !isWebAllowed}
        >
          {webLabel}
        </button>
      </div>
    </div>
  );
};

export default WorkWebToggle;

